module.exports = __webpack_public_path__ + "img/galicia-exporta-empresas.6271b666.png";